import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import css from './popup.module.scss';
import { useOutsideClickTracker } from 'src/hooks/shared-hooks';
import { ReactComponent as Tune } from 'src/assets/tune.svg';
import * as p from 'src/constants/page-classnames';

FiltersPopup.propTypes = {
  onReset: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  pageName: PropTypes.oneOf([p.WORK_SEARCH, p.EVENTS])
};

export default function FiltersPopup({ onReset, children, pageName }) {
  const containerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  useOutsideClickTracker(containerRef, () => {
    if (!isOpen) return;
    setIsOpen(false);
  });

  function handleReset() {
    onReset();
    setIsOpen(false);
  }

  function changePopupState() {
    setIsOpen(!isOpen);
  }

  return (
    <div className={classNames(css.container, css[pageName], isOpen ? css.active : '')} ref={containerRef}>
      <button className={css.filtersButton} onClick={changePopupState}>
        <Tune />
        <span className={css.popupFiltersButtonTitle}>Фільтри</span>
      </button>
      <div className={classNames(css.modal, isOpen ? css.visible : css.hidden)} role='dialog' /* NOSONAR */>
        {children}
        <div className={css.buttonsGroup}>
          <button onClick={changePopupState} className={css.reject}>
            Закрити
          </button>
          <button onClick={handleReset} className={css.reject}>
            Скинути
          </button>
        </div>
      </div>
    </div>
  );
}
